import { cn } from '@/lib/utils'

export interface FilterChip { id: string; label: string; count?: number }
export interface FilterChipRowProps {
  chips: FilterChip[]
  selectedId: string
  onSelect: (id: string) => void
  className?: string
  /** 모바일 가로 스크롤. 기본 false (flex-wrap 줄바꿈). */
  scrollable?: boolean
}

export function FilterChipRow({
  chips,
  selectedId,
  onSelect,
  className,
  scrollable = false,
}: FilterChipRowProps) {
  return (
    <div
      className={cn(
        'flex gap-2',
        scrollable
          ? 'overflow-x-auto whitespace-nowrap -mx-4 px-4 md:mx-0 md:px-0 md:flex-wrap md:overflow-visible md:whitespace-normal'
          : 'flex-wrap',
        className,
      )}
    >
      {chips.map((chip) => {
        const on = chip.id === selectedId
        return (
          <button
            key={chip.id}
            type="button"
            onClick={() => onSelect(chip.id)}
            aria-pressed={on}
            className={cn(
              'inline-flex h-9 shrink-0 items-center gap-1.5 rounded-full border bg-lc-bg-primary pl-4 pr-3 text-lc-v3-body-2 font-medium transition-colors',
              on
                ? 'border-[1.5px] border-lc-key-500 bg-lc-bg-key-light font-bold text-lc-key-600'
                : 'border-lc-v3-gray-300 text-lc-text-secondary hover:bg-lc-v3-gray-50',
            )}
          >
            {chip.label}
            {chip.count != null && (
              <span
                className={cn(
                  'grid h-5 min-w-[20px] shrink-0 place-items-center rounded-full px-1.5 text-[11px] font-bold leading-none tabular-nums',
                  on
                    ? 'bg-lc-key-500 text-lc-text-inverse'
                    : 'bg-lc-v3-gray-100 text-lc-text-tertiary',
                )}
              >
                <span>{chip.count}</span>
              </span>
            )}
          </button>
        )
      })}
    </div>
  )
}
